"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asDefaultMenuTout = exports.asDefaultMenuLink = exports.asMenuLink = exports.useIsActiveTrail = exports.asMenuTout = void 0;

var lodash_1 = require("lodash");

var core_1 = require("@bodiless/core");

var fclasses_1 = require("@bodiless/fclasses");

var components_1 = require("@bodiless/components");

var Touts_1 = require("../Touts");

exports.asMenuTout = function (withToutEditors) {
  return lodash_1.flow(fclasses_1.replaceWith(Touts_1.ToutClean), withToutEditors, core_1.withNode, core_1.withNodeKey('title'));
};
/**
 * Hook which can be used to determine if a menu item is part of
 * the current active breadcrumb trail.
 *
 * This hook is only accurate if
 * - The menu is inside a BreadcrumbStoreProvider.
 * - The menu item has been wrapped in asBreadcrumb
 *
 * @return true if the item is in the active trail, false otherwise.
 */


exports.useIsActiveTrail = function () {
  var _a;

  return (_a = components_1.useBreadcrumbContext()) === null || _a === void 0 ? void 0 : _a.isActive();
};

exports.asMenuLink = function (asEditable, asOff) {
  if (asOff === void 0) {
    asOff = fclasses_1.replaceWith(fclasses_1.Span);
  }

  return lodash_1.flow(fclasses_1.replaceWith(fclasses_1.A), core_1.withSidecarNodes(components_1.withBodilessLinkToggle(components_1.asBodilessLink, asOff)('link')), fclasses_1.stylable, asEditable, core_1.withNode, core_1.withNodeKey('title'));
};

exports.asDefaultMenuLink = exports.asMenuLink(lodash_1.identity);
exports.asDefaultMenuTout = exports.asMenuTout(lodash_1.identity);